// extracted by mini-css-extract-plugin
export default {"customer":"iEu1i","mobile-view":"H-c9n","mobileView":"H-c9n"};